"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNetworkDataMessage = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
/** type guard to assert that input to EntityState process core logic has come from NetworkData */
const isNetworkDataMessage = (x) => {
    const c = x;
    return !!c && (0, iotv_v3_types_1.isVOBofType)('Device', c.device) && (0, iotv_v3_types_1.isValidBusinessObject)(c.thing) && !!c.thingShadowState && !!c.timestamp;
};
exports.isNetworkDataMessage = isNetworkDataMessage;
